/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

import PageStatus from './scripts/page-status';
import HeaderMenuMobile from './scripts/header-menu-mobile';
import Accordion from './scripts/accordion';
import LocationSelection from './scripts/location-selection';
import Tabs from './scripts/tabs';
import InteractiveAssistant from './scripts/interactive-assistant';
import LocationPresentation from './scripts/location-presentation';
import SimpleHero from './scripts/simple-hero';
import FloatingBanner from './scripts/floating-banner';

const scripts = [
  PageStatus,
  HeaderMenuMobile,
  Accordion,
  LocationSelection,
  Tabs,
  InteractiveAssistant,
  LocationPresentation,
  SimpleHero,
  FloatingBanner
];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});
